import useOs from '../utility/useOs';

const usePlayStore = () => {
  const { isIOS, isAndroid } = useOs();

  const openAppleStore = (ascAppId: number): void => {
    if (isIOS) {
      window.open(`itms-apps://itunes.apple.com/app/${ascAppId}`, '_blank');

      return;
    }

    window.open(new URL(ascAppId.toString(), 'https://apps.apple.com/app/id'), '_blank');
  };

  const openGooglePlayStore = (bundleId: string): void => {
    window.open(`https://play.google.com/store/apps/details?id=${bundleId}`, '_blank');
  };

  const openStore = ({ ascAppId, bundleId }: { ascAppId?: number; bundleId?: string }): void => {
    if (isIOS && ascAppId) {
      return openAppleStore(ascAppId);
    }

    if (isAndroid && bundleId) {
      openGooglePlayStore(bundleId);
    }
  };

  return {
    openStore,
    openAppleStore,
    openGooglePlayStore,
  };
};

export default usePlayStore;
